var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddToFavoritesInactiveWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.69202L10.248 6.19602L8 0.900024L5.752 6.20402L0 6.69202L4.368 10.476L3.056 16.1L8 13.116L12.944 16.1L11.64 10.476L16 6.69202ZM8 11.62L4.992 13.436L5.792 10.012L3.136 7.70802L6.64 7.40403L8 4.18002L9.368 7.41203L12.872 7.71603L10.216 10.02L11.016 13.444L8 11.62Z",
    fill: "#00143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddToFavoritesInactiveWh);
export default __webpack_public_path__ + "static/media/icon_add_to_favorites_inactive_wh.48371dc0fe6e79cb7190161dcbea6e62.svg";
export { ForwardRef as ReactComponent };